import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  styled,
  Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import moment from "moment";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/ArrowIcon.svg";
import styles from "../../styles";
import { milestoneStatusStyleArray } from "../../config";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const StyledTableCellWithoutPadding = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  padding: "0 !important",
}));

export default function CommissionDetails({ details }) {
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRowExpansion = (groupId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "45%",
        overflow: "none !important",
        boxShadow: "none",
        maxHeight: "87vh",
        marginTop: "2vh",
      }}
    >
      <Table
        sx={{
          "& thead": {
            "& th": {
              color: "#949DAA",
              fontWeight: "500",
            },
          },
          "& tbody": {
            "& tr:hover": {
              backgroundColor: "#f7f7f7",
            },
            "& tr": {
              borderBottom: "none",
            },
          },
        }}
      >
        <TableHead>
          <TableRow>
            <StyledTableCell>Commission</StyledTableCell>
            <StyledTableCell sx={{ textAlign: "right" }}>
              <strong
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                Amount ({renderCurrencyIcon('small')})
              </strong>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <React.Fragment>
            <TableRow>
              <StyledTableCell>Reno Commission</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.commission
                    ? formattedAmountWithoutAed(details?.commission)
                    : "-"}
                </strong>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Package Cost</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>
                  {details?.commission
                    ? formattedAmountWithoutAed(
                        details?.cost - details?.commission
                      )
                    : "-"}
                </strong>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>Package Price</StyledTableCell>
              <StyledTableCell sx={{ textAlign: "right" }}>
                <strong>{formattedAmountWithoutAed(details?.cost)}</strong>
              </StyledTableCell>
            </TableRow>
          </React.Fragment>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
